let localeMutable;

if (typeof navigator !== 'undefined') {
  if (navigator.languages && navigator.languages.length > 0) {
    [localeMutable] = navigator.languages;
  } else if (navigator.language) {
    localeMutable = navigator.language;
  } else if (navigator.userLanguage) {
    localeMutable = navigator.userLanguage;
  }
} else {
  localeMutable = 'en-US';
}

export const locale = localeMutable;

const localeParts = localeMutable.split('-');

export const country = localeParts.len > 1 ? localeParts[1] : 'US';

// TODO(clairbee): why does LANG_PRESET take precedence over the value we already export through `locale`?
export const language = () => (window.LANG_PRESET ? window.LANG_PRESET : localeParts[0]);
